// extracted by mini-css-extract-plugin
export default {"wrapper":"L4-z","play":"M4-z"};